import { Injectable } from '@angular/core';
import { ResourceManagerService } from '../resource.manager.service';
import { EnvironmentService } from '../environment.service';
import {Material, Mesh, MeshPhysicalMaterial, Object3D} from 'three';
import { CustomMaterialType } from './custom-material-type.enum';
import { MaterialRegistry } from './material-registry';

interface LazyMaterialItem {
    model: Object3D;
    materialType: CustomMaterialType;
}

@Injectable({
    providedIn: 'root'
})
export class MaterialService {
    private materialCache = new Map<CustomMaterialType, Material>();
    private lazyMaterialList: LazyMaterialItem[] = []; // List of items that need to be processed when the material is loaded

    constructor(
        private resourceManager: ResourceManagerService,
        private environmentService: EnvironmentService
    ) {
        MaterialRegistry.autoRegisterMaterials().then(r => {
            console.log("MaterialService: autoRegisterMaterials done");
            //this.processLazyMaterials();
        });
    }

    /**
     * Get material for the given type. If the material is not in the cache, it will be created.
     * @param type
     */
    public async getMaterial(type: CustomMaterialType): Promise<Material> {
        if (this.materialCache.has(type)) {
            return this.materialCache.get(type).clone();
        }

        const material = await MaterialRegistry.createMaterial(type, this.resourceManager, this.environmentService);
        this.materialCache.set(type, material);
        return material.clone();
    }

    /**
     * Set material for the given model. This is used to process materials for models that are loaded before the material is ready.
     * @param model
     * @param materialType
     */
    public lazyLoadMaterial(model: Object3D, materialType: CustomMaterialType): void {
        this.lazyMaterialList.push({ model, materialType });
    }

    /**
     * Process all items in the lazy material list.
     */
    public async processLazyMaterials(): Promise<void> {
        const itemsToProcess = [...this.lazyMaterialList];
        this.lazyMaterialList = [];

        console.log('LAZYMATERIALS', itemsToProcess);

        for (const item of itemsToProcess) {
            try {
                const material = await this.getMaterial(item.materialType);
                item.model.traverse((child) => {
                    if (child instanceof Mesh) {
                        child.material = material;
                    }
                });
            } catch (error) {
                console.error('MaterialService: lazy material processing failed for', item, error);
            }
        }
    }

    public disposeAllMaterials(): void {
        this.materialCache.forEach((material) => {
            if (material instanceof MeshPhysicalMaterial) {
                material.dispose();
            }
        });
        this.materialCache.clear();
    }
}
